
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works/how-to-use",
      function () {
        return require("private-next-pages/how-it-works/how-to-use.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-it-works/how-to-use"])
      });
    }
  